import Markdown from 'markdown-to-jsx';
import { useMemo } from 'react';

export default function StandartTerms({ data, flag }) {
    const countriesLocalizationsData = useMemo(
        () =>
            data?.reduce((acc, el) => {
                acc[el.lang] = { terms_of_use: el.terms_of_use };
                return acc;
            }, {}),
        [data],
    );

    return (
        <div className="table-wrapper">
            <div className="markdown-wrapper">
                <Markdown>
                    {countriesLocalizationsData?.[flag]?.terms_of_use ||
                        'No Terms of Use added'}
                </Markdown>
            </div>
        </div>
    );
}
